import { CloudDone, Spa } from "@mui/icons-material";
import axios from "axios";
import moment from "moment";
import html2pdf from "html2pdf.js";
import React, { useEffect, useState } from "react";
import configs, { getParameterByName } from "../Constants";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Currencies from "../root/currency";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import Card from "@mui/material/Card";
import { useIntl } from "react-intl";
import { Box, IconButton } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import PrintIcon from "@mui/icons-material/Print";

const Reports = () => {
  const [statusType, setStatusType] = useState("inProgressOrders");
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [showMostOrdered, setShowMostOrdered] = useState(false);
  const [handleDate, setHandleDate] = useState([]);
  const [fliterData, setFilterData] = useState([]);
  const [mostOrdered, setMostOrdered] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [report, setReport] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState("Since Open");
  const [todaySummary, setTodaySummary] = useState(true);
  const [mostFilter, setMostFilter] = useState("all");
  const [value, setValue] = React.useState(1);
  const [payViaFilter, setPayViaFilter] = useState("All");
  const [orderDetails, setOrderDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [customDate, setCustomDate] = useState(false);
  const tdStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
  };
  const thStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#f0f0f0",
  };
  let baseURL = configs.baseURL;
  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";

  const userId = userData ? userData.sub : " ";
  console.log(baseURL + "/api/orders/report/" + userId);

  let merchantData = sessionStorage.getItem("merchantData")
    ? JSON.parse(sessionStorage.getItem("merchantData"))
    : null;
  let merchCode = merchantData ? merchantData.merchantCode : "";
  if (userData && userData.role == 'FRANCHISE-ADMIN' && sessionStorage.getItem("branch-merchants")) {
    let branchMer = sessionStorage.getItem("branch-merchants");
    branchMer = branchMer ? JSON.parse(branchMer) : [];
    if (branchMer.length) {
      merchCode = merchCode + '-' + branchMer.join('-');
    }
  }
  const getCatByUser = `${baseURL}/api/categories?merchantCode=${merchCode}`;
  const getProductByUser = `${baseURL}/api/products?merchantCode=${merchCode}`;
  let currency = Currencies.filter(
    (curen) => curen.abbreviation == merchantData.currency
  );
  //console.log(currency)
  let SelectCurrency = currency && currency[0] ? currency[0].symbol : "";
  console.log(SelectCurrency);
  console.log(orderDetails);

  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData?.currency || 'USD'
  });

  useEffect(() => {
    handleSummaryPeriod("Since Open");
  }, []);

  const orderStatus1 = (e) => {
    let status = e.target.value;
    if (status === "cancel") {
      let orderItems =
        report.length && report.filter((item) => item.isCanceled);
      setFilterData(orderItems);
      setIsSearch(true);
    } else {
      setFilterData(report);
      setIsSearch(false);
    }
  };

  // const downloadAsPDF = () => {
  //   console.log("Downloading...");

  //   const pdf = new jsPDF("p", "mm");

  //   if (todaySummary) {
  //     pdf.setFontSize(14);
  //     const todayDate = moment().format("DD-MM-YYYY");
  //     let y = 5;
  //     const items = [
  //       `Total Orders: ${fullReports ? fullReports.length : 0}`,
  //       `Total Amount: ${totalAmount}`,
  //       `Cancelled Orders: ${cancelOrders.length}`,
  //       `Total Tax: ${totalTax}`,
  //       `POS Orders: ${eposOrders.length}`,
  //       `POS Amount: ${eposAmount}`,
  //       `SOK Orders: ${sokOrders.length}`,
  //       `SOK Amount: ${sokAmount}`,
  //       `TOK Orders: ${tokOrders.length}`,
  //       `TOK Amount: ${tokAmount}`,
  //     ];
  //     pdf.text(`Daily Sales summary`, 14, (y += 1));
  //     pdf.text(`Date: ${todayDate}`, 14, (y += 7));
  //     items.forEach((item) => {
  //       pdf.text(item, 14, (y += 8));
  //     });

  //     pdf.save(`Report_${todayDate}.pdf`);
  //   } else {
  //     const rowsPerPage = 40;
  //     const totalRows = fullReports.length;
  //     let currentPage = 1;
  //     let yPos = 0;
  //     let overallRowIndex = 0;

  //     const addPage = () => {
  //       if (currentPage > 1) {
  //         pdf.addPage();
  //       }
  //       yPos = 0;
  //     };

  //     const tableHeader = [
  //       "#Token",
  //       "",
  //       "Price(Inc Tax)",
  //       "Time",
  //       "Payment",
  //       "More",
  //     ];
  //     addPage();
  //     tableHeader.forEach((header, index) => {
  //       pdf.text(header, 10 + index * 50, 10 + yPos);
  //     });
  //     yPos += 30 + 30;

  //     for (let i = 0; i < totalRows; i += rowsPerPage) {
  //       if (i > 0) addPage();
  //       const pageRows = fullReports.slice(i, i + rowsPerPage);
  //       pageRows.forEach((row, rowIndex) => {
  //         const rowData = [
  //           `# ${row.number}`,
  //           row.orderType === "Eat in" ? "Eat In" : "Take Out",
  //           row.discountAmount
  //             ? row.discountType === "price"
  //               ? row.totalPrice - row.discountAmount
  //               : row.totalPrice - (row.totalPrice * row.discountAmount) / 100
  //             : row.totalPrice,
  //           moment(`${row.createdAt}`).format("DD-MM-YYYY h:m a"),
  //           row.paymentType === "Pay here" ? "Online" : "Cash",
  //         ];
  //         rowData.forEach((data, colIndex) => {
  //           pdf.text(data.toString(), 10 + colIndex * 50, 30 + yPos);
  //         });
  //         yPos += 10;
  //       });
  //       currentPage++;
  //     }

  //     pdf.save("Report.pdf");
  //   }

  // };

  const downloadAsExcel = () => {
    console.log("fullReports", fullReports);
    console.log("Downloading as Excel...");

    let excelData = [];

    // Check the selected filter (most ordered, least ordered, etc.)
    if (mostFilter === "itemWise") {
      excelData = aggregateItemWise().map(item => ({
        "Category": item.category,
        "Item": item.name,
        "Quantity Sold": item.isWeight ? "-" : item.quantity,
        "Weight Sold": item.isWeight ? (item.weight >= 1000 ? `${(item.weight / 1000).toFixed(2)} kg` : `${item.weight} g`) : "-",
        "Unit Price": item.isWeight ? formatter.format(item.unitPrice).replace('JMD', 'J$').replace(/\s+/, "") + '/kg' : formatter.format(item.unitPrice).replace('JMD', 'J$').replace(/\s+/, ""),
        "Total Revenue": item.revenue.toFixed(2)
      }));
    } else if (mostFilter === "mostOrdered" || mostFilter === "leastOrdered") {
      // Aggregate orders based on most/least ordered items
      excelData = aggregateOrders(); // Get sorted and aggregated orders
    } else {
      // Default case: Generate Excel based on the full reports
      excelData = fullReports.map((row) => {
        const discountAmount = row.discountAmount ? row.discountAmount : 0;

        return {
          "Token /Tabel Number": row.number,
          "Order Type":
            row.orderType === "Eat In"
              ? "Eat In"
              : row.orderType === "Table Order"
                ? "Table Order"
                : "Take Away",
          "Price (Inc Tax)":
            row.discountType === "discount" || row.discountType === "price"
              ? row.totalPrice - discountAmount
              : row.totalPrice - (row.totalPrice * discountAmount) / 100,
          Time: moment(`${row.createdAt}`).format("DD-MM-YYYY h:m a"),

          Payment:
            row.payVia === "CASH"
              ? "Cash"
              : row.payVia === "UPI"
                ? "UPI"
                : row.payVia === "CARD"
                  ? "Card"
                  : row.payVia === "COUPON"
                    ? "Coupon"
                    : "UPI",
          "Merchant": row.userId
        };
      });
    }

    // Generate the Excel sheet from the aggregated data
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "sales_report.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // const downloadAsExcel = () => {
  //   console.log("fullReports", fullReports);
  //   console.log("Downloading as Excel...");
  //   const excelData = fullReports.map((row) => {
  //     const discountAmount = row.discountAmount ? row.discountAmount : 0;

  //     return {
  //       "Token /Tabel Number": row.number,
  //       "Order Type":
  //         row.orderType === "Eat In"
  //           ? "Eat In"
  //           : row.orderType === "Table Order"
  //           ? "Table Order"
  //           : "Take Away",
  //       "Price (Inc Tax)":
  //         row.discountType === "discount" || row.discountType === "price"
  //           ? row.totalPrice - discountAmount
  //           : row.totalPrice - (row.totalPrice * discountAmount) / 100,
  //       Time: moment(`${row.createdAt}`).format("DD-MM-YYYY h:m a"),

  //       Payment:
  //         row.payVia === "CASH"
  //           ? "Cash"
  //           : row.payVia === "UPI"
  //           ? "UPI"
  //           : row.payVia === "CARD"
  //           ? "Card"
  //           : row.payVia === "COUPON"
  //           ? "Coupon"
  //           : "UPI",
  //     };
  //   });

  //   const workbook = XLSX.utils.book_new();
  //   const worksheet = XLSX.utils.json_to_sheet(excelData);
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const blob = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   const url = URL.createObjectURL(blob);
  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = "Report.xlsx";
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  //   URL.revokeObjectURL(url);
  // };

  const downloadAsPDF = () => {
    const inputId = (value === 0) ? "pdfTarget" : "pdfSummaryTarget";
    const input = document.getElementById(inputId);

    if (!input) {
      console.error("Element not found for PDF capture.");
      return;
    }

    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Sales_Report.pdf");
    });
  };

  const handlePrint = (summaryData) => {
    let printDetails = {};

    printDetails.printType = "summary-report";
    printDetails.summaryData = summaryData;
    let isAndroid = false;
    if (window.PrintInterface) {
      isAndroid = true;
      window.PrintInterface.print(JSON.stringify(printDetails));

    }
    if (!isAndroid && window?.chrome?.webview?.postMessage) {
      window.chrome.webview.postMessage(printDetails);
    }
  };

  const orderListHandler = (itemId) => {
    let orderItems = report.filter((item) => item.id === itemId);
    setOrderDetails(orderItems[0]);
    setIsOpen(true);
  };

  let fullReports = isSearch ? fliterData : report;
  console.log(fullReports);

  const handleMostOrdered = () => {
    setShowMostOrdered(true);
    const orderCounts = {};
    console.log("orders", fullReports);
    fullReports && fullReports?.forEach((order) => {
      order.orderItems.forEach((item) => {
        if (orderCounts[item.name]) {
          orderCounts[item.name] += item.quantity;
        } else {
          orderCounts[item.name] = item.quantity;
        }
      });
    });

    const sortedOrders = Object.entries(orderCounts)
      .sort((a, b) => b[1] - a[1])
      .map(([name, quantity]) => ({ name, quantity }));

    setMostOrdered(sortedOrders);
  };

  const handleClose = (period) => {
    if (period) {
      setSelectedPeriod(period);
      handleSummaryPeriod(period);
    }
  };

  const handleSummaryPeriod = (period) => {
    setTodaySummary(true);
    let startDate, endDate;
    const today = new Date();

    switch (period) {
      case "Yesterday":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 1);
        endDate = new Date(startDate);
        break;
      case "Last Week":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 7);
        endDate = new Date(today);
        break;
      case "Last Month":
        startDate = new Date(today);
        startDate.setMonth(today.getMonth() - 1);
        endDate = new Date(today);
        break;
      case "Custom Date":
        setCustomDate(true);
      case "Today":
        startDate = new Date(today);
        endDate = new Date(today);
        break;
      case "Since Open":
        startDate = "";
        endDate = "";
        break;
      default:
        startDate = new Date(today);
        endDate = new Date(today);
    }

    startDate ? setFromDate(startDate?.toISOString().split("T")[0]) : setFromDate("");
    endDate ? setToDate(endDate?.toISOString().split("T")[0]) : setToDate("");
  };

  useEffect(() => {
    axios.get(getCatByUser).then((response) => {
      console.log(response.data);
      setCategories(response.data);
    });
    axios.get(getProductByUser).then((response) => {
      console.log(response.data);
      setProducts(response.data);
    });

  }, []);

  useEffect(() => {
    if (value == 1 && selectedPeriod.toUpperCase() == 'SINCE OPEN') {
      axios
        .get(
          `${baseURL}/api/orders/recent?merchantCode=${merchCode}`
        )
        .then((response) => {
          console.log(response.data);
          setReport(response.data);
        })
        .catch((error) => {
          console.error("Error fetching report data:", error);
        });
      return;
    }
    else if (fromDate && toDate) {
      axios
        .get(
          `${baseURL}/api/orders/recent?merchantCode=${merchCode}`
        )
        .then((res) => {
          let recents = res.data.filter((item) => {
            const itemTime = new Date(item.updatedAt).getTime();
            const fromTime = new Date(fromDate).getTime();
            const toTime = new Date(toDate).getTime() + 86400000;
            return itemTime >= fromTime && itemTime < toTime;
          });
          console.log(recents);
          axios
            .get(
              `${baseURL}/api/orders/report/${merchCode}?start_date=${fromDate}&end_date=${toDate}`
            )
            .then((response) => {
              console.log(response.data);
              setReport([...recents, ...response.data]);
            })
            .catch((error) => {
              console.error("Error fetching report data:", error);
            });
        });
    }
  }, [fromDate, toDate, baseURL, merchCode]);
  const totalAmount = fullReports
    ? fullReports.reduce((sum, item) => item.orderType?.toLowerCase() === 'refund' ? sum - item.totalPrice : sum + item.totalPrice, 0)
    : 0;
  const cancelOrders = fullReports
    ? fullReports.filter((item) => item.isCanceled === true)
    : 0;
  const totalTax = fullReports
    ? fullReports.reduce((sum, item) => item.orderType?.toLowerCase() === 'refund' ? sum - item.taxPrice : sum + item.taxPrice, 0)
    : 0;
  const cgst = (totalTax / 2).toFixed(2);
  const sgst = (totalTax / 2).toFixed(2);
  const eposOrders = fullReports
    ? fullReports.filter((item) => item.orderSource === "EPOS")
    : 0;
  const sokOrders = fullReports
    ? fullReports.filter((item) => item.orderSource === "Self Order")
    : 0;
  const tokOrders = fullReports
    ? fullReports.filter((item) => item.orderSource === "Table Order")
    : 0;
  const oosOrders = fullReports
    ? fullReports.filter((item) => item.orderSource === "Online Order")
    : 0;

  const eposAmount = eposOrders
    ? eposOrders.reduce((acc, item) => item.orderType?.toLowerCase() === 'refund' ? acc - item.totalPrice : acc + item.totalPrice, 0)
    : 0;
  const sokAmount = sokOrders
    ? sokOrders.reduce((acc, item) => item.orderType?.toLowerCase() === 'refund' ? acc - item.totalPrice : acc + item.totalPrice, 0)
    : 0;
  const tokAmount = tokOrders
    ? tokOrders.reduce((acc, item) => item.orderType?.toLowerCase() === 'refund' ? acc - item.totalPrice : acc + item.totalPrice, 0)
    : 0;
  const oosAmount = oosOrders
    ? oosOrders.reduce((acc, item) => item.orderType?.toLowerCase() === 'refund' ? acc - item.totalPrice : acc + item.totalPrice, 0)
    : 0;

  const refundOrders = fullReports
    ? fullReports.filter((item) => item.orderType?.toLowerCase() === 'refund')
    : [];
  const totalRefundAmount = refundOrders.reduce((acc, item) => acc + item.totalPrice, 0);
  const totalRefundOrders = refundOrders.length;

  const discount = fullReports
    ? fullReports.reduce((acc, item) => acc + (item.discountAmount || 0), 0)
    : 0;
  const netAmount = totalAmount - totalTax;
  const total = totalAmount;
  const igst = 0;

  const payViaDistribution = fullReports
    ? fullReports.reduce((acc, ord) => {
      const method = ord.payVia?.toUpperCase() || merchantData?.defaultPaymentMethod?.toUpperCase() || "CASH";
      const val = ord.orderType?.toLowerCase() === 'refund' ? -ord.totalPrice : ord.totalPrice;
      acc[method] = (acc[method] || 0) + val;
      return acc;
    }, {})
    : {};

  // console.log(cancelOrders);

  const { formatMessage: t, locale, setLocale } = useIntl();

  const handleFilterChange = (event) => {
    const filter = event.target.value;
    setMostFilter(filter);

    if (filter.toLowerCase() === "all") {
      setShowMostOrdered(false);
    } else {
      setShowMostOrdered(true);
    }
  };

  const aggregateOrders = () => {
    const orderCounts = {};
    console.log(fullReports);
    fullReports && fullReports?.forEach((order) => {
      const isRefund = order.orderType?.toLowerCase() === "refund";
      order.orderItems.forEach((item) => {
        orderCounts[item.name] = (orderCounts[item.name] || 0) + (isRefund ? -item.quantity : item.quantity);
      });
    });

    // Convert aggregated data into a sorted array based on quantity
    return Object.entries(orderCounts)
      .map(([name, quantity]) => ({ name, quantity }))
      .sort((a, b) =>
        mostFilter === "mostOrdered"
          ? b.quantity - a.quantity
          : a.quantity - b.quantity
      );
  };

  const aggregateItemWise = () => {
    const stats = {};
    fullReports && fullReports?.forEach((order) => {
      const isRefund = order.orderType?.toLowerCase() === "refund";
      order.orderItems?.forEach((item) => {
        if (!stats[item.name]) {
          stats[item.name] = { quantity: 0, revenue: 0, weight: 0, isWeight: false };
        }
        const isWeight = item.select_type === "weight" || (item.is_weight_type && item.weight_price > 0);
        stats[item.name].isWeight = isWeight;

        if (isWeight) {
          const weight = isRefund ? -item.quantity : item.quantity;
          stats[item.name].weight += weight;
          // In this system, price for weight-type items is stored as weight_price which is per 1000g (1kg)
          stats[item.name].revenue += (weight / 1000) * item.price;
          stats[item.name].unitPrice = item.price;
        } else {
          stats[item.name].quantity += isRefund ? -item.quantity : item.quantity;
          stats[item.name].revenue += isRefund ? -(item.quantity * item.price) : (item.quantity * item.price);
          stats[item.name].unitPrice = item.price;
        }

        const prod = products.find(prd => prd._id == item._id || prd.id == item._id);
        if (prod) {
          const cat = categories.find(cat => cat._id == prod.category || cat.id == prod.category);
          stats[item.name].category = cat ? cat.name : "Uncategorized";
        } else {
          stats[item.name].category = "Uncategorized";
        }
      });
    });
    return Object.entries(stats).map(([name, { quantity, revenue, category, weight, isWeight, unitPrice }]) => ({
      name,
      quantity,
      revenue,
      category,
      weight,
      isWeight,
      unitPrice
    })).sort((a, b) => {
      const nameA = a.category.toUpperCase();
      const nameB = b.category.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  };

  const groupItemsByCategory = () => {
    const items = aggregateItemWise();
    const grouped = {};

    items.forEach(item => {
      if (!grouped[item.category]) {
        grouped[item.category] = [];
      }
      grouped[item.category].push(item);
    });

    return grouped;
  };

  const allOrders = aggregateOrders();
  console.log(allOrders);
  let filteredOrders = [...allOrders];

  if (mostFilter === "mostOrdered") {
    filteredOrders.sort((a, b) => b.quantity - a.quantity);
  } else if (mostFilter === "leastOrdered") {
    filteredOrders.sort((a, b) => a.quantity - b.quantity);
  }
  console.log(filteredOrders);
  const backHandler = () => {
    setShowMostOrdered(false);
    setTodaySummary(false);
    setMostFilter("all");
  };

  const handlePayViaFilter = (value) => {
    setPayViaFilter(value);

    if (value === "All") {
      setFilterData(report); // show all orders
      setIsSearch(false);
    } else {
      const filtered = report.filter(
        (item) =>
          item.payVia && item.payVia.toUpperCase() === value.toUpperCase()
      );
      setFilterData(filtered);
      setIsSearch(true);
    }
  };

  const handleDateView = () => {
    setValue(0); // Switch to Date View
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    setFromDate(formattedDate);
    setToDate(formattedDate);
  };

  const handleSummaryView = () => {
    setValue(1); // Switch to Summary View
    setFromDate(null);
    setToDate(null);
  };

  return (
    <div className="container bg-light">
      <div className="header">
        <h4 align="left">Reports</h4>
        <Box
          sx={{
            // width: "100%",
            // bgcolor: "background.paper",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ButtonGroup aria-label="Basic button group">
            <Button
              variant={value === 0 ? "contained" : "outlined"}
              style={{
                backgroundColor: value === 0 ? "#F7C919" : "inherit",
                borderColor: value === 0 ? "#F7C919" : "inherit",
                color: value === 0 ? "black" : "inherit",
                borderColor: "#F7C919",
              }}
              onClick={handleDateView}
            >
              Detail View
            </Button>
            <Button
              variant={value === 1 ? "contained" : "outlined"}
              style={{
                backgroundColor: value === 1 ? "#F7C919" : "inherit",
                borderColor: value === 1 ? "#F7C919" : "inherit",
                color: value === 1 ? "black" : "inherit",
                borderColor: "#F7C919",
              }}
              onClick={handleSummaryView}
            >
              Summary View
            </Button>
          </ButtonGroup>
        </Box>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: "10px",
            padding: "8px",
            borderRadius: "50px",
            border: "none",
            backgroundColor: "white",
            color: "#007bff",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid #007bff",
          }}
        >

        </button>
      </div>
      <div
        style={{
          padding: "12px",
          backgroundColor: "white",
          borderRadius: "10px",
          margin: "10px",
          height: "80vh",
          overflow: "hidden",
          overflowY: "scroll"
        }}
      >
        <div className="sub-container report_filter">
          {(value === 0 || customDate) && (
            <span style={{ display: "flex", gap: "10px" }}>
              <div>
                <label htmlFor="">From:</label>
                <br />
                <input
                  type="date"
                  className="mx-3"
                  onChange={(e) => setFromDate(e.target.value)}
                  style={{
                    borderRadius: "5px",
                    outline: "none",
                    border: "1px solid #ccc",
                  }}
                  value={fromDate}
                />
              </div>
              <div>
                <label htmlFor="">To:</label>
                <br />
                <input
                  type="date"
                  className="mx-3"
                  onChange={(e) => setToDate(e.target.value)}
                  style={{
                    borderRadius: "5px",
                    outline: "none",
                    border: "1px solid #ccc",
                  }}
                  value={toDate}
                />
              </div>
            </span>
          )}


          {value === 1 && (
            <span>
              <label htmlFor="">Summary Type</label>
              <br />
              <select
                value={mostFilter}
                onChange={handleFilterChange}
                style={{
                  border: "1px solid #ccc",
                  outline: "none",
                  width: "120px",
                  borderRadius: "5px",
                }}
              >
                <option value="all">All Orders</option>
                <option value="mostOrdered">Most Ordered </option>
                <option value="leastOrdered">Least Ordered</option>
                <option value="itemWise">Category-Items-wise</option>

              </select>
            </span>
          )}

          {value === 1 && (
            <>
              <span>
                <label htmlFor="">Date From</label>
                <br />
                <select
                  value={selectedPeriod}
                  onChange={(e) => handleClose(e.target.value)}
                  style={{
                    border: "1px solid #ccc",
                    outline: "none",
                    width: "120px",
                    borderRadius: "5px",
                  }}
                >
                  <option value="Since Open">Since Open</option>
                  <option value="Today">Today</option>
                  <option value="Yesterday">Yesterday</option>
                  <option value="Last Week">Last Week</option>
                  <option value="Last Month">Last Month</option>
                  <option value="Custom Date">Custom Date</option>
                </select>
              </span>
              <span>
                <label htmlFor="">PayVia</label>
                <br />
                <select
                  value={payViaFilter}
                  onChange={(e) => handlePayViaFilter(e.target.value)}
                  style={{
                    border: "1px solid #ccc",
                    outline: "none",
                    width: "120px",
                    borderRadius: "5px",
                  }}
                >
                  <option value="All">All</option>
                  {(() => {
                    const allPaymentMethods = [
                      { value: "0", label: "CASH" },
                      { value: "1", label: "UPI" },
                      { value: "2", label: "CARD" },
                      { value: "3", label: "COUPON" },
                      { value: "4", label: "CREDIT" },
                    ];
                    const enabledMethods = merchantData?.paymentMethods
                      ? allPaymentMethods.filter(m => merchantData.paymentMethods.split(",").includes(m.value))
                      : allPaymentMethods;

                    return enabledMethods.map(m => (
                      <option key={m.value} value={m.label}>{m.label}</option>
                    ));
                  })()}
                </select>
              </span>
            </>
          )}
          <span className="m-3 ">
            <label htmlFor="">Status</label>
            <br />
            <select
              onChange={orderStatus1}
              style={{
                border: "1px solid #ccc",
                outline: "none",
                width: "120px",
                borderRadius: "5px",
              }}
            >
              <option value="">All</option>
              <option value="cancel">Cancelled</option>
            </select>
          </span>
          <span>
            <Button
              variant="contained"
              color="info"
              style={{ margin: "8px" }}
              onClick={downloadAsExcel}
            >
              Excel
            </Button>
            <Button
              variant="outlined"
              color="warning"
              style={{ margin: "8px" }}
              onClick={downloadAsPDF}
            >
              Pdf
            </Button>
          </span>
        </div>

        {false && (
          <div
            className="button-container"
            style={{ disflex: "flex", justifyContent: "space-between" }}
          >
            <Button
              variant="contained"
              color="primary"
              style={
                showMostOrdered
                  ? { opacity: "initial" }
                  : { opacity: "0", cursor: "none" }
              }
              onClick={backHandler}
            >
              Back
            </Button>
          </div>
        )}

        {value === 0 && (
          <div
            id="pdfTarget"
            style={{
              overflow: "scroll",
              maxHeight: "60vh",
              backgroundColor: "white",
            }}
          >
            <table
              className="r-responsive-table"
              style={{ width: "100%", fontSize: "18px" }}
            >
              <thead style={{ background: "#fff" }}>
                <tr>
                  <th>#Token</th>
                  <th></th>
                  <th>Price(Inc Tax)</th>
                  <th>Time</th>
                  <th>Payment</th>
                  <th>More</th>
                  <th>Merchant</th>
                </tr>
              </thead>
              <tbody>
                {fullReports?.length
                  ? fullReports.map((ord, key) => (
                    <tr key={key} style={{ textAlign: "center" }}>
                      <td># {ord.number}</td>
                      <td>
                        <img
                          height="20px"
                          width="20px"
                          alt=""
                          src={
                            ord.orderType === "Eat In"
                              ? "/images/eat_in.png"
                              : ord.orderType === "Table Order"
                                ? "/images/tableOrder.png"
                                : "/images/take-out-2.png"
                          }
                        />
                      </td>
                      <td>{ord.totalPrice.toFixed(2)}</td>
                      <td style={{ fontSize: "12px" }}>
                        {moment(ord.createdAt).format(
                          "DD-MM-YYYY h:m a"
                        )}
                      </td>
                      <td>
                        {{
                          CASH: "Cash",
                          UPI: "UPI",
                          CARD: "Card",
                          COUPON: "Coupon",
                        }[ord?.payVia?.toUpperCase() || merchantData?.defaultPaymentMethod] || "CASH"}
                      </td>
                      <td>
                        <button
                          className="btn"
                          id="show_btn"
                          onClick={() => orderListHandler(ord.id)}
                        >
                          <ReceiptLongOutlinedIcon />
                        </button>

                      </td>
                      <td>{ord.userId}</td>
                    </tr>
                  ))
                  : ""}
              </tbody>
            </table>
          </div>
        )}

        {value === 1 && (
          <div id="pdfSummaryTarget" style={{ backgroundColor: "white", padding: "10px" }}>
            <div style={{ marginLeft: "20px", marginBottom: "20px", textAlign: "center", fontSize: "18px" }}>
              <h3>{selectedPeriod} {mostFilter === "all" ? t({ id: "daily_summary" }) : (mostFilter === "itemWise" ? "Category-Items-wise Report" : "Ordered Items Report")}</h3>
              <b>
                {selectedPeriod === "Since Open" && fullReports?.length > 0
                  ? `${moment(Math.min(...fullReports.map(o => new Date(o.createdAt).getTime()))).format("DD/MM/YYYY")} ~ ${moment(Math.max(...fullReports.map(o => new Date(o.createdAt).getTime()))).format("DD/MM/YYYY")}`
                  : moment(fromDate).format("DD/MM/YYYY")}
                {toDate && selectedPeriod !== "Today" && selectedPeriod !== "Yesterday" && selectedPeriod !== "Since Open" ? ` ~ ${moment(toDate).format("DD/MM/YYYY")}` : ""}
              </b>
            </div>

            {mostFilter === "itemWise" && (
              // --- New Item-Wise Table ---
              <div
                style={{ overflow: "auto", maxHeight: "60vh", padding: "10px" }}
              >
                <table
                  className="r-responsive-table"
                  style={{
                    width: "100%",
                    fontSize: "18px",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead style={{ backgroundColor: "#f1f1f1" }}>
                    <tr>
                      <th style={tdStyle}>Item</th>
                      <th style={tdStyle}>Qnty Sold</th>
                      <th style={tdStyle}>Weight Sold</th>
                      <th style={tdStyle}>Unit Price</th>
                      <th style={tdStyle}>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(groupItemsByCategory()).length > 0 ? (
                      Object.entries(groupItemsByCategory()).map(([category, items], catIdx) => {
                        const categorySubtotal = items.reduce((sum, item) => sum + item.revenue, 0);
                        return (
                          <React.Fragment key={catIdx}>
                            {/* Category Header Row */}
                            <tr style={{ backgroundColor: "#e0e0e0" }}>
                              <td
                                colSpan="5"
                                style={{
                                  ...tdStyle,
                                  fontWeight: "bold",
                                  fontSize: "20px",
                                  textAlign: "left",
                                  padding: "15px",
                                }}
                              >
                                {category}
                              </td>
                            </tr>
                            {/* Items under this category */}
                            {items.map((item, idx) => (
                              <tr key={idx} style={{ backgroundColor: "#ffffff" }}>
                                <td style={tdStyle}>{item.name}</td>
                                <td style={tdStyle}>{item.isWeight ? "-" : item.quantity}</td>
                                <td style={tdStyle}>
                                  {item.isWeight
                                    ? item.weight >= 1000
                                      ? `${(item.weight / 1000).toFixed(2)} kg`
                                      : `${item.weight} g`
                                    : "-"}
                                </td>
                                <td style={tdStyle}>
                                  {item.isWeight ? formatter.format(item.unitPrice).replace('JMD', 'J$').replace(/\s+/, "") + '/kg' : formatter.format(item.unitPrice).replace('JMD', 'J$').replace(/\s+/, "")}
                                </td>
                                <td style={tdStyle}>{item.revenue.toFixed(2)}</td>
                              </tr>
                            ))}
                            {/* Category Subtotal Row */}
                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                              <td
                                colSpan="2"
                                style={{
                                  ...tdStyle,
                                  fontWeight: "bold",
                                  textAlign: "right",
                                  padding: "12px",
                                  fontSize: "0.8em!important"
                                }}
                              >
                                {category} Subtotal:
                              </td>
                              <td
                                colSpan="2"
                                style={{ ...tdStyle, backgroundColor: "#f5f5f5" }}
                              ></td>
                              <td
                                style={{
                                  ...tdStyle,
                                  fontWeight: "bold",
                                  padding: "12px",
                                }}
                              >
                                {categorySubtotal.toFixed(2)}
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan="3"
                          style={{
                            textAlign: "center",
                            padding: "15px",
                            border: "1px solid #ddd",
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            {(mostFilter === "mostOrdered" || mostFilter === "leastOrdered") && (
              // --- Most/Least Ordered Table ---
              <div
                style={{ overflow: "auto", maxHeight: "60vh", padding: "10px" }}
              >
                <table
                  className="r-responsive-table"
                  style={{
                    width: "100%",
                    fontSize: "18px",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead style={{ backgroundColor: "#f1f1f1" }}>
                    <tr>
                      <th style={tdStyle}>Item</th>
                      <th style={tdStyle}>Qnty Ordered</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredOrders.length ? (
                      filteredOrders.map((item, index) => (
                        <tr key={index} style={{ backgroundColor: "#ffffff" }}>
                          <td style={tdStyle}>{item.name}</td>
                          <td style={tdStyle}>{item.quantity}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="2"
                          style={{
                            textAlign: "center",
                            padding: "15px",
                            border: "1px solid #ddd",
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            {mostFilter === "all" && (
              <Card
                id="card"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto",
                  padding: "20px",
                  width: "fit-content",
                  border: "1px solid #ddd",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <h3>{t({ id: "daily_summary" })}</h3>
                  <IconButton onClick={() => handlePrint({
                    date: moment(fromDate).format("DD/MM/YYYY"),
                    totalOrders: (fullReports?.length || 0),
                    totalAmount: totalAmount.toFixed(2),
                    tax: totalTax.toFixed(2),
                    discount: discount.toFixed(2),
                    netAmount: netAmount.toFixed(2),
                    cgst: cgst,
                    sgst: sgst,
                    igst: igst.toFixed(2),
                    total: total.toFixed(2),
                    totalRefundOrders,
                    totalRefundAmount: totalRefundAmount.toFixed(2),
                    payViaDistribution
                  })} color="primary" className="no-print">
                    <PrintIcon />
                  </IconButton>
                </div>
                <b>{selectedPeriod === "Since Open" && fullReports?.length > 0
                  ? `${moment(Math.min(...fullReports.map(o => new Date(o.createdAt).getTime()))).format("DD/MM/YYYY")} ~ ${moment(Math.max(...fullReports.map(o => new Date(o.createdAt).getTime()))).format("DD/MM/YYYY")}`
                  : moment(fromDate).format("DD/MM/YYYY")}</b>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <span>{t({ id: "total_orders" })}:</span>
                  <span>{fullReports ? fullReports.length : 0}</span>
                </span>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <span>{t({ id: "total_ammount" })}:</span>
                  <span>{parseFloat(totalAmount).toFixed(2)}</span>
                </span>

                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "200px",
                    color: 'red'
                  }}
                >
                  <span>Total Refunds:</span>
                  <span>{totalRefundOrders}</span>
                </span>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "200px",
                    color: 'red'
                  }}
                >
                  <span>Refund Amount:</span>
                  <span>{totalRefundAmount.toFixed(2)}</span>
                </span>

                <div style={{ marginTop: '10px', borderTop: '1px solid #eee', paddingTop: '10px' }}>
                  <b style={{ fontSize: '14px' }}>Payment Mode Distribution</b>
                  {Object.entries(payViaDistribution).map(([method, amount]) => (
                    <span
                      key={method}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "200px",
                        fontSize: '14px'
                      }}
                    >
                      <span>{method}:</span>
                      <span>{amount.toFixed(2)}</span>
                    </span>
                  ))}
                </div>
                {/* <span
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "200px",
                }}
              >
                <span>CGST:</span>
                <span>{cgst}</span>
              </span>
              <span
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "200px",
                }}
              >
                <span>SGST :</span>
                <span>{sgst}</span>
              </span> */}
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <span>Total Tax :</span>
                  <span>{totalTax.toFixed(2)}</span>
                </span>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <span>POS {t({ id: "orders" })}:</span>
                  <span>{eposOrders.length}</span>
                </span>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <span>POS {t({ id: "ammount" })}:</span>
                  <span>{parseFloat(eposAmount).toFixed(2)}</span>

                </span>
                {merchantData?.bizVertical?.toUpperCase() == 'RESTAURANT' && <div><span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <span>Kiosk {t({ id: "orders" })}:</span>
                  <span>{sokOrders.length}</span>
                </span>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "200px",
                    }}
                  >
                    <span>Kiosk {t({ id: "ammount" })}:</span>
                    <span>{sokAmount}</span>
                  </span>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "200px",
                    }}
                  >
                    <span>Table {t({ id: "orders" })}:</span>
                    <span>{tokOrders.length}</span>
                  </span>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "200px",
                    }}
                  >
                    <span>Table {t({ id: "ammount" })}:</span>
                    <span>{tokAmount}</span>
                  </span></div>}
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <span>Online {t({ id: "orders" })}:</span>
                  <span>{oosOrders.length}</span>
                </span>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <span>Online{t({ id: "ammount" })}:</span>
                  <span>{oosAmount.toFixed(2)}</span>
                </span>
              </Card>
            )}
          </div>
        )}
        <Dialog
          className="dialog-box"
          maxWidth="md"
          fullWidth={true}
          open={isOpen}
        >
          <div style={{ padding: "20px" }} className="order-tab">
            <h5 align="center">
              Order summary token : #
              <span style={{ fontSize: "35px" }}>
                {orderDetails && orderDetails.number}
              </span>
            </h5>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "16px",
                marginTop: "10px",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.05)",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f5f5f5" }}>
                  <th style={thStyle}>Name</th>
                  <th style={thStyle}>Quantity / Weight</th>
                  <th style={thStyle}>Price</th>
                </tr>
              </thead>
              <tbody>
                {orderDetails &&
                  orderDetails.orderItems.map((orderItem, index) => (
                    <tr key={index}>
                      <td style={tdStyle}>{orderItem.name}</td>
                      <td style={tdStyle}>
                        {orderItem.select_type === "weight"
                          ? orderItem.quantity >= 1000
                            ? `${(orderItem.quantity / 1000).toFixed(
                              orderItem.quantity % 1000 === 0 ? 0 : 1
                            )} kg`
                            : `${orderItem.quantity} g`
                          : orderItem.quantity}
                      </td>
                      <td style={tdStyle}>₹{orderItem.price}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <Button
              variant="contained"
              color="error"
              style={{ float: "right", margin: "9px" }}
              onClick={() => setIsOpen(false)}
            >
              Close
            </Button>
          </div>
        </Dialog>
      </div>
    </div >
  );
};

export default Reports;
